import { FC } from "react"

import { useTimezone } from "hooks/useTimezone"

import { TournamentReferralReward } from "types/tournament.types"

interface ReferralRewardHistoryProps {
  rewards: TournamentReferralReward[]
}

export const ReferralRewardHistory: FC<ReferralRewardHistoryProps> = ({ rewards }) => {
  const { formatDateTime } = useTimezone()

  if (rewards.length === 0) return null

  return (
    <div className="px-6 pb-6">
      <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Reward History</h4>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 dark:bg-[rgba(139,92,246,0.05)]">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Referrer</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Referee</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Type</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Trigger</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Points</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[rgba(0,0,0,0.05)] dark:divide-[rgba(255,255,255,0.1)]">
            {rewards.map((reward) => (
              <tr key={reward.id} className="hover:bg-gray-50 dark:hover:bg-[rgba(139,92,246,0.05)]">
                <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">{reward.referrer_username}</td>
                <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">{reward.referee_username}</td>
                <td className="px-4 py-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300">
                    {reward.reward_type?.toLowerCase().replace(/_/g, " ") || "-"}
                  </span>
                </td>
                <td className="px-4 py-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
                    {reward.reward_trigger?.toLowerCase() || "-"}
                  </span>
                </td>
                <td className="px-4 py-2 text-sm font-medium text-green-600 dark:text-green-400">+{reward.points_awarded}</td>
                <td className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">{formatDateTime(reward.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
